module.exports = __webpack_public_path__ + "media/images/icons/icon_bullet_grey-dc34c5d13cd9f93295ccd7f336448832.svg";